import React, { Component } from 'react';
import { MAIN_CONFIG } from '../../config/main';
import DonorApplicationsPage from '../../Modules/Pages/Donor/DonorApplicationsPage/DonorApplicationsPage';
import ApplicantScholarshipPage from '../../Modules/Pages/Applicant/ApplicantScholarshipPage/ApplicantScholarshipPage';
const { USER_CONTEXT } = MAIN_CONFIG;
import SwitchRoleLoader from '../../Modules/Pages/SwitchRoleLoader/SwitchRoleLoader';

export default class DonorApplicationsContainer extends Component {

    static async getInitialProps(context) {
        return DonorApplicationsPage.getInitialProps(context, MAIN_CONFIG.PAGE_TYPES.DONOR.APPLICATIONS);
    }

    render() {
        const { userContext } = this.props;

        switch (userContext) {
            case USER_CONTEXT.DONOR:
            case USER_CONTEXT.SUPERDONOR:
            case USER_CONTEXT.REVIEWER:
            case USER_CONTEXT.RECOMMENDER:
            case USER_CONTEXT.NGB:
            case USER_CONTEXT.SCHOOLCOUNSELLOR:
            case USER_CONTEXT.ENDORSEDUSER:
            case USER_CONTEXT.THIRDPARTYCONTRIBUTOR:
            case USER_CONTEXT.VERIFIER:
            case USER_CONTEXT.ADMIN:
                return <SwitchRoleLoader { ...this.props }/>
            case USER_CONTEXT.APPLICANT:
            case USER_CONTEXT.TEAMMEMBER:
            case USER_CONTEXT.LOGGED_OUT:
                return <ApplicantScholarshipPage { ...this.props } />;
            default:
                return null
        }
    }
}

